import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useDataProvider } from 'src/app/common/utils';
import { PaginateList } from 'src/app/common/types';
import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import { PruTableSortTypeEnum } from 'src/app/common/components/PruTable/PruTable';
import { AdminReportBatchFileListItem } from 'src/app/modules/OpmPd/types/opm-pd-admin-report-types';
import {
  FetchAdminReportBatchFilesParams,
  fetchAdminReportBatchFiles,
} from 'src/app/modules/OpmPd/network/opm-pd-admin-report';
import { isEmpty } from 'src/app/modules/OpmPd/utils/commonHelper';

const initialState: FetchAdminReportBatchFilesParams = {
  page: 1,
  limit: 5,
};

const paramsInitiator = (initialParams?: Record<string, string>): FetchAdminReportBatchFilesParams => {
  return initialParams
    ? {
        page: 1,
        limit: 5,
        ...initialParams,
      }
    : initialState;
};

export const useAdminReportBatchFilePruTable = ({ initialParams, onChangeQueryParams }: ParamsProps) => {
  const dispatch = useDispatch();
  const [filterState, setFilterState] = useState<FetchAdminReportBatchFilesParams>(paramsInitiator(initialParams));
  const [adminReportBatchFiles, setAdminReportBatchFiles] = useState<PaginateList<AdminReportBatchFileListItem>>();

  const { isLoading, refreshData } = useDataProvider<PaginateList<AdminReportBatchFileListItem>>(
    async () => {
      try {
        if (onChangeQueryParams) {
          onChangeQueryParams(filterState);
        }
        const params = Object.fromEntries(Object.entries(filterState).filter(([, v]) => !isEmpty(v))) as any;
        return await fetchAdminReportBatchFiles(params, dispatch);
      } catch (err) {}
    },
    setAdminReportBatchFiles,
    false,
  );

  const onSort = (newSortState: { key: string; value?: string }) => {
    const { key, value } = newSortState;
    if (value) {
      let newSort = '';
      switch (value) {
        case PruTableSortTypeEnum.ASC:
          newSort = key;
          break;
        case PruTableSortTypeEnum.DESC:
          newSort = `-${key}`;
          break;
      }
      setFilterState({ ...filterState, sort: newSort });
    } else {
      setFilterState({ ...filterState, sort: undefined });
    }
    refreshData();
  };

  return {
    filterState,
    adminReportBatchFiles,
    isLoading,
    setFilterState,
    refreshData,
    onSort,
  };
};
